import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { GrupoClassificacaoSelectComponent } from './grupo-classificacao-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        GrupoClassificacaoSelectComponent
    ],
    exports: [
        GrupoClassificacaoSelectComponent
    ]
})
export class GrupoClassificacaoSelectModule { }
